import React from 'react'

import { CreditBuilderValuePropContainer } from '../../common/credit-builder/value-prop/CreditBuilderValuePropContainer'

export const OnboardingCreditBuilderValuePropContainer = () => {
  return <CreditBuilderValuePropContainer />
}
